
<script>
import MonthPicker from './MonthPicker'

export default {
  mixins: [ MonthPicker ],
  data() {
    return {
      buttonContainerClass: 'quarterly'
    }
  },
  computed: {
    selectedQuarterNumber() {
      return Math.floor(this.selectedDate.getMonth()/3)
    },
    selectedDateText() {
      return `${this.selectedDate.getFullYear()}-${this.selectedQuarterNumber+1}분기`
    },
    selectedStartDate() {
      return new Date(this.selectedDate.getFullYear(), this.selectedQuarterNumber * 3)
    },
    selectedEndDate() {
      const endDate = new Date(this.selectedStartDate)
      endDate.setMonth(endDate.getMonth() + 3)
      endDate.setDate(endDate.getDate() - 1)
      endDate.setHours(23, 59, 59, 999)
      return endDate
    }
  },
  methods: {
    buttonClass(item) {
      return {
        active: item.selectedQuarter,
        disabled: item.disabled
      }
    }
  }
}
</script>
